// src/components/Contact/ContactMethodField.js
import React from 'react';

const ContactMethodField = ({ value, onChange }) => {
  return (
    <div className="form-field grid-field">
      <label className="amplify-label" htmlFor="contact-method">
        Contact Method
      </label>

      <div className="amplify-select__wrapper">
        <select
          id="contact-method"
          className="amplify-select amplify-field-group__control amplify-select--quiet"
          value={value}
          onChange={onChange}
          required
        >
          <option value="email">Email</option>
          
          <option value="text">Text</option>
          <option value="no-contact">No Contact</option>
        </select>

        <div className="amplify-flex amplify-select__icon" aria-hidden="true">
          <span style={{ width: '1em', height: '1em' }} className="amplify-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactMethodField;
